import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    gridRight: {
        paddingRight: 5 ,
    },
    gridLeft: {
        textAlign: 'left',
        paddingLeft: 5
    },
    costRoot: {
        backgroundColor: theme.palette.primary.contrastText,
        textAlign: 'center',
        marginTop: 10,
        borderRadius: 30,
        paddingTop: 5,
        paddingBottom: 5
    },
    amount: {
        fontSize: 14,
        color: theme.palette.color.gray
    } ,
    rial :{
        fontSize: 12,
        color: theme.palette.color.gray
    }
}))
